import React, { useState } from 'react';
import { articles } from '../data/articles';
import useScrollReveal from '../hooks/useScrollReveal';
import './FeaturedIn.css';

const logoStyles = {
  TimeOut: { fontFamily: "'Arial Black', sans-serif", fontWeight: 900, fontSize: '1.6rem', color: '#000', WebkitTextStroke: '1px #000' },
  JPost: { fontWeight: 800, fontSize: '1rem', color: '#000', letterSpacing: '0.5px' },
  GirlsWhoCode: { fontWeight: 700, fontSize: '1rem', color: '#E8C840', letterSpacing: '1px' },
  BlogHer: { fontWeight: 900, fontSize: '1.3rem', color: '#E23B3B', letterSpacing: '1px', textTransform: 'uppercase' },
  Stanford: { fontWeight: 700, fontSize: '1rem', color: '#8C1515' },
  JewishNews: { fontWeight: 700, fontSize: '1rem', color: '#1A5AAB' },
  MsMagazine: { fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: '1.8rem', color: '#000', fontStyle: 'italic' },
  '4iMag': { fontWeight: 800, fontSize: '1.2rem', color: '#4CAF50' },
  Nylon: { fontWeight: 400, fontSize: '1.4rem', color: '#E91E90', letterSpacing: '8px', textTransform: 'uppercase' },
  TheJC: { fontWeight: 700, fontSize: '1rem', color: '#1a1a1a' },
  BizJournals: { fontWeight: 700, fontSize: '1rem', color: '#0066cc' },
  IsraelDefense: { fontWeight: 800, fontSize: '1rem', color: '#1a3a5c', letterSpacing: '0.5px' },
};

const logoText = {
  TimeOut: 'Time Out',
  JPost: 'THE JERUSALEM POST',
  GirlsWhoCode: 'girls who code',
  BlogHer: 'BLOGHER',
  Stanford: 'Stanford University',
  JewishNews: 'The Jewish News',
  MsMagazine: 'Ms.',
  '4iMag': '4i-mag',
  Nylon: 'NYLON',
  TheJC: 'The JC',
  BizJournals: 'Biz Journals',
  IsraelDefense: 'Israel Defense',
};

function FeaturedIn() {
  const [gridRef, gridVisible] = useScrollReveal();
  const [showAll, setShowAll] = useState(false);
  const visibleArticles = showAll ? articles : articles.slice(0, 8);

  return (
    <section className="featured section" id="featured">
      <div className="container">
        <h2 className="section-title">
          In the<span className="gold-accent"> News</span>
        </h2>
        <br></br>

        <div ref={gridRef} className={`featured__grid reveal-children ${gridVisible ? 'visible' : ''}`}>
          {visibleArticles.map((article) => (
            <div className="featured__card" key={article.id}>
              <div className="featured__logo" style={logoStyles[article.logo] || {}}>
                {logoText[article.logo] || article.source}
              </div>
              <p className="featured__title">{article.title}</p>
              <a
                href={article.url}
                target="_blank"
                rel="noopener noreferrer"
                className="featured__read"
              >
                Read Article →
              </a>
            </div>
          ))}
        </div>

        {articles.length > 8 && (
          <div className="featured__more">
            <button className="featured__more-btn" onClick={() => setShowAll(!showAll)}>
              {showAll ? 'Show Less' : 'See More News'}
            </button>
          </div>
        )}
      </div>

      <div className="wave-divider">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
        </svg>
      </div>
    </section>
  );
}

export default FeaturedIn;
